
export default [
    {
        "name": "Played First Game",
        "category": "Overall",
        "title": "Let the Games Begin",
        "description": "Played First Game",
        "image": "ace.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "1",
        "check": function (p) { return p["win"] > 0 || p["loss"] > 0 }
    },
    {
        "name": "5 Easy Wins",
        "category": "Easy",
        "title": "Piece of Cake",
        "description": "Win 5 matches on Easy",
        "image": "cake-slice.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "2",
        "check": function (p) { return p["win_Easy"] >= 5 }
    },
    {
        "name": "5 Medium Wins",
        "category": "Medium",
        "title": "Made Flight",
        "description": "Win 5 matches on Medium",
        "image": "butterfly.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "3",
        "check": function (p) { return p["win_Medium"] >= 5 }
    },
    {
        "name": "10 Medium Wins",
        "category": "Medium",
        "title": "Quick Flyer",
        "description": "Win 10 matches on Medium",
        "image": "dragonfly.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "4",
        "check": function (p) { return p["win_Medium"] >= 10 }
    },
    {
        "name": "20 Medium Wins",
        "category": "Medium",
        "title": "Growing Force",
        "description": "Win 20 matches on Medium",
        "image": "bee.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "5",
        "check": function (p) { return p["win_Medium"] >= 20 }
    },
    {
        "name": "50 Medium Wins",
        "category": "Medium",
        "title": "Little Fighter",
        "description": "Win 50 matches on Medium",
        "image": "wasp-sting.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "6",
        "check": function (p) { return p["win_Medium"] >= 50 }
    },
    {
        "name": "100 Medium Wins",
        "category": "Medium",
        "title": "Little Champion ",
        "description": "Win 100 matches on Medium",
        "image": "scarab-beetle.png",
        "points": "70",
        "pushToFacebook": "true",
        "order": "7",
        "check": function (p) { return p["win_Medium"] >= 100 }
    },
    {
        "name": "5 Hard Wins",
        "category": "Hard",
        "title": "Got Your Feet Wet",
        "description": "Win 5 matches on Hard",
        "image": "ammonite.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "9",
        "check": function (p) { return p["win_Hard"] >= 5 }
    },
    {
        "name": "10 Hard Wins",
        "category": "Hard",
        "title": "Neigh to Losing",
        "description": "Win 10 matches on Hard",
        "image": "horse-head.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "10",
        "check": function (p) { return p["win_Hard"] >= 10 }
    },
    {
        "name": "20 Hard Wins",
        "category": "Hard",
        "title": "Hard to Beat",
        "description": "Win 20 matches on Hard",
        "image": "turtle.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "11",
        "check": function (p) { return p["win_Hard"] >= 20 }
    },
    {
        "name": "50 Hard Wins",
        "category": "Hard",
        "title": "Fast And Silent",
        "description": "Win 50 matches on Hard",
        "image": "frog.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "12",
        "check": function (p) { return p["win_Hard"] >= 50 }
    },
    {
        "name": "100 Hard Wins",
        "category": "Hard",
        "title": "Choice Fish",
        "description": "Win 100 matches on Hard",
        "image": "angler-fish.png",
        "points": "70",
        "pushToFacebook": "true",
        "order": "13",
        "check": function (p) { return p["win_Hard"] >= 100 }
    },
    {
        "name": "5 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Ninja Has Awaken",
        "description": "Win 5 matches on CrazyNinja",
        "image": "sleepy.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "14",
        "check": function (p) { return p["win_CrazyNinja"] >= 5 }
    },
    {
        "name": "10 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Sparing Partner",
        "description": "Win 10 matches on CrazyNinja",
        "image": "ninja-mask.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "15",
        "check": function (p) { return p["win_CrazyNinja"] >= 10 }
    },
    {
        "name": "20 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Black Belt",
        "description": "Win 20 matches on CrazyNinja",
        "image": "iron-mask.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "16",
        "check": function (p) { return p["win_CrazyNinja"] >= 20 }
    },
    {
        "name": "50 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Merciless",
        "description": "Win 50 matches on CrazyNinja",
        "image": "tear-tracks.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "17",
        "check": function (p) { return p["win_CrazyNinja"] >= 50 }
    },
    {
        "name": "100 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Ninja Destroyer",
        "description": "Win 100 matches on CrazyNinja",
        "image": "pummeled.png",
        "points": "70",
        "pushToFacebook": "true",
        "order": "18",
        "check": function (p) { return p["win_CrazyNinja"] >= 100 }
    },
    // {
    //     "name": "1 Insane Monkey Win",
    //     "category": "Insane Monkey",
    //     "title": "Distinguished Warrior",
    //     "description": "Win 1 match on Insane Monkey",
    //     "image": "monkey.png",
    //     "points": "25",
    //     "pushToFacebook": "true",
    //     "order": "121",
    //     "check": function (p) { return p["win_InsaneMonkey"] >= 1 }
    // },
    // {
    //     "name": "5 Insane Monkey Wins",
    //     "category": "Insane Monkey",
    //     "title": "Monkey Dominator",
    //     "description": "Win 5 matches on Insane Monkey",
    //     "image": "totem-head.png",
    //     "points": "25",
    //     "pushToFacebook": "true",
    //     "order": "122",
    //     "check": function (p) { return p["win_InsaneMonkey"] >= 5 }
    // },
    // {
    //     "name": "20 Insane Monkey Wins",
    //     "category": "Insane Monkey",
    //     "title": "Monkey Dominator",
    //     "description": "Win 20 matches on Insane Monkey",
    //     "image": "totem-head.png",
    //     "points": "50",
    //     "pushToFacebook": "true",
    //     "order": "122",
    //     "check": function (p) { return p["win_InsaneMonkey"] >= 20 }
    // },
    // {
    //     "name": "1 UltraCheetah Win",
    //     "category": "UltraCheetah",
    //     "title": "Hello Cheetah",
    //     "description": "Win 1 match on UltraCheetah",
    //     "image": "anthem.png",
    //     "points": "25",
    //     "pushToFacebook": "true",
    //     "order": "121",
    //     "check": function (p) { return p["win_UltraCheetah"] >= 1 }
    // },
    // {
    //     "name": "10 UltraCheetah Wins",
    //     "category": "UltraCheetah",
    //     "title": "Speed Cheetah",
    //     "description": "Win 10 matches on UltraCheetah",
    //     "image": "anthem.png",
    //     "points": "50",
    //     "pushToFacebook": "true",
    //     "order": "122",
    //     "check": function (p) { return p["win_UltraCheetah"] >= 10 }
    // },
    // {
    //     "name": "30 UltraCheetah Wins",
    //     "category": "UltraCheetah",
    //     "title": "Cheetah Dominator",
    //     "description": "Win 30 matches on UltraCheetah",
    //     "image": "energy-arrow.png",
    //     "points": "100",
    //     "pushToFacebook": "true",
    //     "order": "122",
    //     "check": function (p) { return p["win_UltraCheetah"] >= 30 }
    // },
    // {
    //     "name": "1 Impossible Win",
    //     "category": "Impossible",
    //     "title": "Impossible Path",
    //     "description": "Win 1 match on Impossible",
    //     "image": "evil-tree.png",
    //     "points": "25",
    //     "pushToFacebook": "true",
    //     "order": "121",
    //     "check": function (p) { return p["win_Impossible"] >= 1 }
    // },
    // {
    //     "name": "10 Impossible Wins",
    //     "category": "Impossible",
    //     "title": "Impossible Boom",
    //     "description": "Win 10 matches on Impossible",
    //     "image": "explosive-materials.png",
    //     "points": "50",
    //     "pushToFacebook": "true",
    //     "order": "122",
    //     "check": function (p) { return p["win_Impossible"] >= 10 }
    // },
    // {
    //     "name": "30 Impossible Wins",
    //     "category": "Impossible",
    //     "title": "Not Possible",
    //     "description": "Win 30 matches on Impossible",
    //     "image": "extra-lucid.png",
    //     "points": "100",
    //     "pushToFacebook": "true",
    //     "order": "122",
    //     "check": function (p) { return p["win_Impossible"] >= 30 }
    // },
    {
        "name": "5 Wins",
        "category": "Overall",
        "title": "Reached Noob Status",
        "description": "Win 5 matches",
        "image": "mouse.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "19",
        "check": function (p) { return p["win"] >= 5 }
    },
    {
        "name": "50 Wins",
        "category": "Overall",
        "title": "Reached Noob+ Status",
        "description": "Win 50 matches",
        "image": "mouse.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "19",
        "check": function (p) { return p["win"] >= 50 }
    },
    {
        "name": "100 Wins",
        "category": "Overall",
        "title": "Small Beginnings ",
        "description": "Win 100 matches",
        "image": "mouse.png",
        "points": "50",
        "pushToFacebook": "true",
        "order": "20",
        "check": function (p) { return p["win"] >= 100 }
    },
    {
        "name": "200 Wins",
        "category": "Overall",
        "title": "Consistent Flyer",
        "description": "Win 200 matches",
        "image": "bird-twitter.png",
        "points": "100",
        "pushToFacebook": "true",
        "order": "21",
        "check": function (p) { return p["win"] >= 200 }
    },
    {
        "name": "300 Wins",
        "category": "Overall",
        "title": "Quiet Potential",
        "description": "Win 300 matches",
        "image": "white-cat.png",
        "points": "150",
        "pushToFacebook": "true",
        "order": "22",
        "check": function (p) { return p["win"] >= 300 }
    },
    {
        "name": "400 Wins",
        "category": "Overall",
        "title": "Dangerous Foe",
        "description": "Win 400 matches",
        "image": "scorpion.png",
        "points": "200",
        "pushToFacebook": "true",
        "order": "23",
        "check": function (p) { return p["win"] >= 400 }
    },
    {
        "name": "500 Wins",
        "category": "Overall",
        "title": "Slippery Predator ",
        "description": "Win 500 matches",
        "image": "squid.png",
        "points": "200",
        "pushToFacebook": "true",
        "order": "24",
        "check": function (p) { return p["win"] >= 500 }
    },
    {
        "name": "600 Wins",
        "category": "Overall",
        "title": "Power Player",
        "description": "Win 600 matches",
        "image": "hound.png",
        "points": "250",
        "pushToFacebook": "true",
        "order": "25",
        "check": function (p) { return p["win"] >= 600 }
    },
    {
        "name": "700 Wins",
        "category": "Overall",
        "title": "Quick and Formidable",
        "description": "Win 700 matches",
        "image": "lion.png",
        "points": "300",
        "pushToFacebook": "true",
        "order": "26",
        "check": function (p) { return p["win"] >= 700 }
    },
    {
        "name": "800 Wins",
        "category": "Overall",
        "title": "Unstoppable Force",
        "description": "Win 800 matches",
        "image": "croc-jaws.png",
        "points": "300",
        "pushToFacebook": "true",
        "order": "27",
        "check": function (p) { return p["win"] >= 800 }
    },
    {
        "name": "900 Wins",
        "category": "Overall",
        "title": "It's Dinomight!",
        "description": "Win 900 matches",
        "image": "dinosaur-rex.png",
        "points": "300",
        "pushToFacebook": "true",
        "order": "28",
        "check": function (p) { return p["win"] >= 900 }
    },
    {
        "name": "1000 Wins",
        "category": "Overall",
        "title": "Soaring Above The Competition",
        "description": "Win 1000 matches",
        "image": "eagle-emblem.png",
        "points": "500",
        "pushToFacebook": "true",
        "order": "29",
        "check": function (p) { return p["win"] >= 1000 }
    },
    // {
    //     "name": "1500 Wins",
    //     "category": "Overall",
    //     "title": "King of Cards",
    //     "description": "Win 1500 matches",
    //     "image": "king.png",
    //     "points": "1000",
    //     "pushToFacebook": "true",
    //     "order": "30",
    //     "check": function (p) { return p["win"] >= 1500 }
    // }, {
    //     "name": "2000 Wins",
    //     "category": "Overall",
    //     "title": "King of Cards",
    //     "description": "Win 2000 matches",
    //     "image": "king.png",
    //     "points": "1500",
    //     "pushToFacebook": "true",
    //     "order": "30",
    //     "check": function (p) { return p["win"] >= 2000 }
    // },
    {
        "name": "Win Easy 5 times in a row",
        "category": "Easy",
        "title": "Dominator",
        "description": "Win Easy 5 times in a row",
        "image": "palm.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "31",
        "order": "30",
        "check": function (p) { return p["win_streak_Easy"] >= 5 }
    },
    {
        "name": "Win Medium 5 times in a row",
        "category": "Medium",
        "title": "Dominator",
        "description": "Win Medium 5 times in a row",
        "image": "palm.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "32",
        "check": function (p) { return p["win_streak_Medium"] >= 5 }
    },
    {
        "name": "Win Hard 5 times in a row",
        "category": "Hard",
        "title": "Dominator",
        "description": "Win Hard 5 times in a row",
        "image": "palm.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "33",
        "check": function (p) { return p["win_streak_Hard"] >= 5 }
    },
    {
        "name": "Win Crazy Ninja 5 times in a row",
        "category": "CrazyNinja",
        "title": "Dominator",
        "description": "Win Crazy Ninja 5 times in a row",
        "image": "palm.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "34",
        "check": function (p) { return p["win_streak_CrazyNinja"] >= 5 }
    },
    {
        "name": "Win Easy 7 times in a row",
        "category": "Easy",
        "title": "On Fire",
        "description": "Win Easy 7 times in a row",
        "image": "paw.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "35",
        "check": function (p) { return p["win_streak_Easy"] >= 7 }
    },
    {
        "name": "Win Medium 7 times in a row",
        "category": "Medium",
        "title": "On Fire",
        "description": "Win Medium 7 times in a row",
        "image": "paw.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "36",
        "check": function (p) { return p["win_streak_Medium"] >= 7 }
    },
    {
        "name": "Win Hard 7 times in a row",
        "category": "Hard",
        "title": "On Fire",
        "description": "Win Hard 7 times in a row",
        "image": "paw.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "37",
        "check": function (p) { return p["win_streak_Hard"] >= 7 }
    },
    {
        "name": "Win Crazy Ninja 7 times in a row",
        "category": "CrazyNinja",
        "title": "On Fire",
        "description": "Win Crazy Ninja 7 times in a row",
        "image": "paw.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "38",
        "check": function (p) { return p["win_streak_CrazyNinja"] >= 7 }
    },
    {
        "name": "Win Hard 10 times in a row",
        "category": "Hard",
        "title": "Overkill",
        "description": "Win Hard 10 times in a row",
        "image": "flaming-claw.png",
        "points": "50",
        "pushToFacebook": "true",
        "order": "39",
        "check": function (p) { return p["win_streak_Hard"] >= 10 }
    },
    {
        "name": "Win Crazy Ninja 10 times in a row",
        "category": "CrazyNinja",
        "title": "Overkill",
        "description": "Win Crazy Ninja 10 times in a row",
        "image": "flaming-claw.png",
        "points": "50",
        "pushToFacebook": "true",
        "order": "40",
        "check": function (p) { return p["win_streak_CrazyNinja"] >= 10 }
    },
    // {
    //     "name": "Tie Hard 1 time",
    //     "category": "Hard",
    //     "title": "Peacemaker",
    //     "description": "Tie Hard 1 time",
    //     "image": "meditation.png",
    //     "points": "50",
    //     "pushToFacebook": "true",
    //     "order": "55",
    //     "check": function (p) { return p["tie_Hard"] >= 1 }
    // },
    // {
    //     "name": "Tie Crazy Ninja 1 time",
    //     "category": "CrazyNinja",
    //     "title": "Peacemaker",
    //     "description": "Tie Crazy Ninja 1 time",
    //     "image": "meditation.png",
    //     "points": "50",
    //     "pushToFacebook": "true",
    //     "order": "56",
    //     "check": function (p) { return p["tie_CrazyNinja"] >= 1 }
    // },
   
    // {
    //     "name": "5 Online Wins",
    //     "category": "Online",
    //     "title": "Online Noobie",
    //     "description": "Win 5 matches Online",
    //     "image": "duality.png",
    //     "points": "25",
    //     "pushToFacebook": "true",
    //     "order": "106",
    //     "check": function (p) { return p["win_Online"] >= 5 }
    // },
    // {
    //     "name": "10 Online Wins",
    //     "category": "Online",
    //     "title": "Meeting the Competition",
    //     "description": "Win 10 matches Online",
    //     "image": "duality.png",
    //     "points": "25",
    //     "pushToFacebook": "true",
    //     "order": "107",
    //     "check": function (p) { return p["win_Online"] >= 10 }
    // },
    // {
    //     "name": "20 Online Wins",
    //     "category": "Online",
    //     "title": "Beating the Competition",
    //     "description": "Win 20 matches Online",
    //     "image": "backup.png",
    //     "points": "40",
    //     "pushToFacebook": "true",
    //     "order": "108",
    //     "check": function (p) { return p["win_Online"] >= 20 }
    // },
    // {
    //     "name": "50 Online Wins",
    //     "category": "Online",
    //     "title": "Plays To Win",
    //     "description": "Win 50 matches Online",
    //     "image": "backup.png",
    //     "points": "50",
    //     "pushToFacebook": "true",
    //     "order": "109",
    //     "check": function (p) { return p["win_Online"] >= 50 }
    // },
    // {
    //     "name": "100 Online Wins",
    //     "category": "Online",
    //     "title": "Wifi Junkie",
    //     "description": "Win 100 matches Online",
    //     "image": "dark-squad.png",
    //     "points": "100",
    //     "pushToFacebook": "true",
    //     "order": "110",
    //     "check": function (p) { return p["win_Online"] >= 100 }
    // },
    // {
    //     "name": "500 Online Wins",
    //     "category": "Online",
    //     "title": "Online Legend",
    //     "description": "Win 500 matches Online",
    //     "image": "dozen.png",
    //     "points": "50",
    //     "pushToFacebook": "true",
    //     "order": "111",
    //     "check": function (p) { return p["win_Online"] >= 500 }
    // },
    {
        "name": "10 Losses",
        "category": "Overall",
        "title": "Thunder Struck",
        "description": "Lose 10 matches",
        "image": "dozen.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "112",
        "check": function (p) { return p["lose"] > 10 }
    },
    {
        "name": "20 Losses",
        "category": "Overall",
        "title": "Thunder Struck",
        "description": "Lose 20 matches",
        "image": "thunder-struck.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "112",
        "check": function (p) { return p["lose"] > 20 }
    },
    {
        "name": "30 Losses",
        "category": "Overall",
        "title": "Eaten Right Up",
        "description": "Lose 30 matches",
        "image": "fishbone.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "113",
        "check": function (p) { return p["lose"] > 30 }
    },
    {
        "name": "50 Losses",
        "category": "Overall",
        "title": "Swimming in Dangerous Waters",
        "description": "Lose 50 matches",
        "image": "shark-jaws.png",
        "points": "25",
        "pushToFacebook": "true",
        "order": "114",
        "check": function (p) { return p["lose"] > 50 }
    },
    // {
    //     "name": "400 Losses",
    //     "category": "Overall",
    //     "title": "Burned",
    //     "description": "Lose 400 matches",
    //     "image": "salamander.png",
    //     "points": "25",
    //     "pushToFacebook": "true",
    //     "order": "115",
    //     "check": function (p) { return p["lose"] > 400 }
    // },
    // {
    //     "name": "500 Losses",
    //     "category": "Overall",
    //     "title": "Determined to The End",
    //     "description": "Lose 500 matches",
    //     "image": "animal-skull.png",
    //     "points": "25",
    //     "pushToFacebook": "true",
    //     "order": "116",
    //     "check": function (p) { return p["lose"] > 500 }
    // },


    // {
    //     "name": "10 Insane Monkey Losses",
    //     "category": "Insane Monkey",
    //     "title": "Monkey Fighter",
    //     "description": "Lose 10 matches on Insane Monkey",
    //     "image": "monkey.png",
    //     "points": "50",
    //     "pushToFacebook": "true",
    //     "order": "123",
    //     "check": function (p) { return p["lose_InsaneMonkey"] >= 10 }
    // },
    {
        "name": "Rate Game",
        "category": "Other",
        "title": "Courteous Citizen",
        "description": "Rate the game",
        "image": "paw-heart.png",
        "points": "25",
        "order": "117"
    }
    //    ,
    //{
    //    "name": "Invite Facebook Friend",
    //    "category": "Online",
    //    "title": "Get The Party Started",
    //    "description": "Invite a facebook friend",
    //    "image": "minions.png",
    //    "points": "25",
    //    "order": "120"
    //}
    , {
        "name": "See More Games",
        "category": "Other",
        "title": "Dora The Explorer",
        "description": "See More Games",
        "image": "heart-inside.png",
        "points": "25",
        "order": "118"
    }
    // , {
    //     "name": "Steam Game",
    //     "category": "Other",
    //     "title": "Steam Game Open",
    //     "description": "Welcom to Steam!",
    //     "image": "heart-inside.png",
    //     "points": "1500",
    //     "order": "125",
    //     "isHidden": "true",
    //     "check": function (p) { return p["platform"] === "Steam" }
    // }

    //{
    //    "name": "Play Bluetooth Game",
    //    "category": "Online",
    //    "title": "Close Combat",
    //    "description": "Play a bluetooth game",
    //    "image": "telepathy.png",
    //    "points": "25",
    //    "pushToFacebook": "true",
    //    "order": "119"
    //    }

    //,

    ,{
        "name": "titleTapped10",
        "category": "Easy",
        "title": "title Tapper",
        "description": "Tap the title 10 times",
        "image": "wildfires.png",
        "points": "50",
        "item": "CribbageBoardGuitar",
        "order": "1",
        "check": function (p) { return p["titleTapped"] >= 10 }
    },

];